module.exports = __webpack_public_path__ + "assets/img/01-m.0336877.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/01-m.jpg
// module id = OlgI
// module chunks = 0